<template>
      <div no-body class="lku-exp"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else >
        <b-col lg="12">
            <b-input-group >
                <b-input-group-prepend><label >Exp. Number</label></b-input-group-prepend>
                <b-form-input v-model="tblData.nomor" @keyup.13.native="refresh()" size="sm" placeholder="Exp.Reimburs. No"></b-form-input>
                <b-input-group-prepend><label class="text-right">Description</label></b-input-group-prepend>
                  <b-form-input v-model="tblData.uraian" @keyup.13.native="refresh()" size="sm" style="width:40% !important;" placeholder="Description" ></b-form-input>
            </b-input-group>
            <b-input-group >
              <b-input-group-prepend><label >Create By</label></b-input-group-prepend>
              <b-form-input v-model="tblData.createby" @keyup.13.native="refresh()" size="sm" placeholder="Reimburs By"></b-form-input>
              <b-input-group-prepend><label class="text-right">Paid To</label></b-input-group-prepend>
                <b-form-input v-model="tblData.dibayarke" @keyup.13.native="refresh()" size="sm" placeholder="Paid to"></b-form-input>
                <b-input-group-prepend><label class="text-right">Approval </label></b-input-group-prepend>
                <b-form-select v-model="tblData.statuswf" :plain="true" :options="dataList.approvalStatus"></b-form-select>
                <b-input-group-append>
                    <b-button class="btn btn-success ml-3" @click="refresh()" size="sm"> <i class="fa fa-refresh"></i> Apply Filter</b-button>
                </b-input-group-append>
                <b-input-group-append>
                  <b-button class="btn btn-secondary ml-1" @click="clearFilter()" size="sm"> <i class="fa fa-eraser"></i>Clear </b-button>
                </b-input-group-append>
                
            </b-input-group>
        </b-col>

      </b-row>
        <b-table
          class="mb-0"
          ref="tblApinvOst" style="font-size:smaller;" 
          responsive small striped hover
          :items="tblData.items"
          :fields="fields"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="updatetable" 
          @row-clicked="selectItem"
        >
        <!-- <template v-slot:cell(tanggal)="data">
          {{ data.item.tanggal | moment("DD MMM YYYY") }}
        </template> -->
          <template v-slot:cell(jumlah)="data">
              {{data.item.jumlah | numFormat('0,0.00')}}
          </template>

          <template v-slot:cell(outstand)="data">
            {{data.item.outstand | numFormat('0,0.00')}}
          </template>
        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <input type="number" style="width:80px;" v-model="tblData.limit"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
  </div>
</template>
<style lang="scss">
  .lku-exp {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
    .input-group-prepend {
        label {
            padding-top: 5px;
            padding-right: 5px;
            width: 83px;
        }
    }

  }
</style>

<script>
import expense from "../../apis/expense";
import dropdown from "../../data/dropdown";

export default {
  data() {
    return {
      lkuLoading:false,
      fields: [
          {
            key: "nomor",
            thStyle: "width:100px",
            label: "Trx. Number",
            sortable: true
          },
          {
            key: "keterangan",
            label: "Description",
          },
          {
            key: "dibayarke",
            label: "Paid to",
            sortable: true
          },
          {
            key: "jumlah",
            label: "Requested Amt.",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "outstand",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right"
          },
      ],
      tblData: {
        items:[],
        page: 1,
        limit: 20,
        total: 0,
        sortBy: 'nomor',
        sortDesc: true,
        vendorcode:'',
        outstand : '1',statuswf:'111'
      },
      updatetable:false,
      dataList: {
        approvalStatus:dropdown.approvalStatus,
      },      

    };
  },
  computed: {
    filterVendor() {
      return this.tblData.dibayarke;
    },
    filtervendorcode() {
      return this.tblData.vendorcode;
    },
    pagechange() {
      return this.tblData.page;
    },
    limitchange() {
      return this.tblData.limit;
    },
  },
  watch: {
    pagechange: function(newval) {
      this.tblData.page=newval;
      this.refresh();
    },   
    limitchange: function(newval) {
      this.data();
    },   
    "tblData.sortBy": function(newval) {
      this.data();
    },   
    "tblData.sortDesc": function(newval) {
      this.data();
    },   
  },
  props: ["formdata"],
  created: async function() {
        if (this.formdata.items)
        {
            for (var key in this.formdata) {
                this.tblData[key] = this.formdata[key];
            }
        }

},
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading=true;
      const list = await expense.list(this.tblData);      
      this.lkuLoading=false;
      this.tblData.items=list;
      this.updatetable=!this.updatetable;
      // console.log('this.tblData : ',this.tblData);
    },
    selectItem(item,index) {
      // this.$emit("click", item);
      this.tblData.selected=item;
      this.$emit("click", this.tblData);
    },
    clearFilter() {
        this.tblData.dibayarke= '';
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
    },    
    keymonitor: function(event) {
       if(event.key == "Enter")
       {
        //  console.log('the id of the input was:' + event.currentTarget.id);
        this.$refs.tblApinvOst.refresh();
       }
    },    
    refresh() {
      this.data();
      this.$refs.tblApinvOst.refresh();
    }
  }
};
</script>
